module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-mid-0.64006037.svg";